import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { connect, useSelector } from "react-redux";
import { fetchVideoSeries } from "./store/action";
import Loading from "../components/Loading";
import { VideoSeriesProps } from "./store/actionType";
import SeriesCard from "./page/component/SeriesCard";
import CreateSeries from "./page/CreateSeries";
import { VideoCategoryProps } from "../category/store/actionType";
import { VideoGroupProps } from "../group/store/actionType";
import BreadcrumbFolderLayout from "../components/BreadcrumbFolderLayout";
import { AddFolderButton, SmallScreenModel } from "components";
import { Authorities } from "props/authoritries";
import { useUser } from "utils/helpers/UserContext";
import { SuperAdminStatusEnum } from '../../../props/enum';

type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type StateProps = ReturnType<typeof mapStateToProps>;
type Props = DispatchProps & StateProps;

const Series: React.FC<Props> = ({ videoSeriesState, onFetchVideoSeries }) => {
  const navigate = useNavigate();
  const { groupId } = useParams<{ groupId: string }>();
  const groupsState = useSelector(
    (state: any) => state.videoGroups.videoGroupsState
  );
  const currentGroup = groupsState.groups?.filter(
    (group: VideoGroupProps) => group.id === groupId
  )[0];
  const { categoryId } = useParams<{ categoryId: string }>();
  const categoryState = useSelector(
    (state: any) => state.videoCategories.videoCategoriesState
  );
  const currentCategory = categoryState.categories?.filter(
    (category: VideoCategoryProps) => category.id === categoryId
  )[0];

  const [isModalOpen, setModalOpen] = useState(false);
  const toggleModal = () => setModalOpen(!isModalOpen);
  const closeModel = () => {
    setModalOpen(false);
  };
  const handleSectionClick = (id: string) => {
    navigate(`/video/${groupId}/${categoryId}/${id}`);
  };
  const redirectToGroup = () => {
    navigate(`/video`);
  };
  const redirectToCategory = () => {
    navigate(`/video/${groupId}`);
  };

  useEffect(() => {
    onFetchVideoSeries(categoryId ?? "");
  }, []);
  const breadcrumbItem = [
    {
      group: "Group",
      root: "Root",
      active: true,
      onClick: () => redirectToGroup(),
    },
    {
      group: currentGroup?.name,
      root: "Group",
      active: true,
      onClick: () => redirectToCategory(),
    },
    {
      group: currentCategory?.name,
      root: "Category",
    },
  ];
  const { authUser, action, superAdmin } = useUser();
  const isPermitted =
    authUser &&
    (superAdmin === SuperAdminStatusEnum.SuperAdmin  ||
      action?.includes(Authorities.CREATE_SERIES));
  return (
    <div className="h-full overflow-hidden">
      {videoSeriesState && videoSeriesState.isLoading && <Loading />}
      <BreadcrumbFolderLayout
        groupData={videoSeriesState?.video_series}
        breadcrumbItem={breadcrumbItem}
        addFolderButton={
          <>
            {isPermitted && (
              <AddFolderButton onClick={toggleModal}>
                Create Series
              </AddFolderButton>
            )}
          </>
        }
        folders={
          <>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
              {videoSeriesState &&
                videoSeriesState?.video_series &&
                videoSeriesState?.video_series.map(
                  (seriesData: VideoSeriesProps) => (
                    <SeriesCard
                      key={seriesData.id}
                      seriesData={seriesData}
                      onClick={() => handleSectionClick(seriesData.id)}
                    />
                  )
                )}
            </div>
          </>
        }
      />
      <SmallScreenModel showModal={isModalOpen} setShowModal={setModalOpen}>
        <CreateSeries
          closeModal={closeModel}
          categoryFolderData={currentCategory}
        />
      </SmallScreenModel>
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  videoSeriesState: state.videoSeries?.videoSeriesState,
});

const mapDispatchToProps = (dispatch: any) => ({
  onFetchVideoSeries: (categroy_id: string) =>
    dispatch(fetchVideoSeries(categroy_id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Series);
